<!-- Sidebar Search + Tree -->
<div data-testid="roles-sidebar-container" class="mr-4 sidebar-container">
  <!-- Search Field (replaces All Roles button) -->
  <div class="search-section">
    <app-search-form
      data-testid="roles-sidebar-search-form"
      [searchFormat]="roleSearchConfig"
      (formSearch)="onRoleFormSearch($event)"
      (formReset)="onRoleFormReset()"
    >
      <div slot="actions">
        @if (canCreate) {
          <app-button
            [testId]="'roles-sidebar-create-role-btn'"
            class="create-role-button"
            type="info"
            label="configuration.roles.dialog.create_role"
            (emitOnClick)="onCreateRole()"
          ></app-button>
        }
      </div>
    </app-search-form>
  </div>

  <!-- Tree Container -->
  <div class="tree-container">
    @if (loading()) {
      <div class="loading-container">
        <div data-testid="roles-sidebar-loading" class="custom-spinner"></div>
        <span class="loading-text">{{
          "configuration.roles.sidebar.loading_roles" | translate
        }}</span>
      </div>
    } @else {
      <p-tree
        data-testid="roles-sidebar-tree"
        [value]="filteredTreeData()"
        [selectionMode]="'single'"
        [selection]="selectedNode()"
        (onNodeSelect)="onNodeSelect($event.node)"
        [metaKeySelection]="false"
        class="category-tree"
      >
        <ng-template pTemplate="default" let-node>
          <div
            class="tree-node-content"
            [attr.data-type]="node.data?.type"
            [attr.data-role-name]="node.data?.name"
          >
            <div class="tree-node-title-row w-full">
              <span class="node-label flex-1">
                {{ node.data.name }}
              </span>

              @if (canDelete) {
                <button
                  [attr.data-testid]="
                    'roles-sidebar-delete-role-btn-' + node.data?.id
                  "
                  type="button"
                  class="delete-role-button ml-2"
                  [attr.aria-label]="
                    'configuration.roles.dialog.confirm_delete' | translate
                  "
                  (click)="onDeleteRole($event, node.data)"
                >
                  <i class="pi pi-trash text-sm"></i>
                </button>
              }
            </div>

            <div class="node-description text-gray-600">
              {{ node.data.description }}
            </div>
          </div>
        </ng-template>
      </p-tree>
    }
  </div>
</div>
